import { render, staticRenderFns } from "./Followup_View.vue?vue&type=template&id=26907c92"
import script from "./Followup_View.vue?vue&type=script&lang=js"
export * from "./Followup_View.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports